<div>
  <img
    id="six-arts-logo"
    class="top-padding"
    src="assets/images/six_arts_logo_long.png"
    routerLink="/six-arts"
  />

  <div style="text-align: left;">
    <p id="back-link">
      <a routerLink="/six-arts">返回</a>
    </p>
  </div>
</div>

<hr>
<div ng *ngIf="course">
<h1 class="display-4">Edit Class</h1>
  <form #form="ngForm" autocomplete="off" (submit)="onSubmit(form)">
      <div class="form-row">
        <div class="form-group col-md-3">
          <input  name="id" #id="ngModel" [(ngModel)]="course.id" class="form-control" readonly>
          <label>ID</label>
        </div>
        <div class="form-group col-md-3">
          <input name="name" #name="ngModel" [(ngModel)]="course.name" class="form-control" required>
          <div *ngIf="name.invalid && name.touched" class="validation-error">This field is required.</div>
          <label>Course Name</label>
        </div>
        <!-- <div class="form-group  col-md-6">
          <input type="color" #color="ngModel" [(ngModel)]="course.color" class="form-control" value="#ff0000" style="width:50%;">
        </div> -->
        <!-- <div class="form-group col-md-3">
          <input [(colorPicker)]="course.color" [(ngModel)]="course.color"
          [cpAlphaChannel]="'disabled'" name="color" [value]="course.color" [style.background]="course.color"/>
          <label>Course Color</label>

        </div> -->


      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <select name="day" #day="ngModel" [(ngModel)]="course.day" class="form-control">
            <option value="MON">星期一</option>
            <option value="TUE">星期二</option>
            <option value="WED">星期三</option>
            <option value="THUR">星期四</option>
            <option value="FRI">星期五</option>
          </select>
          <label>星期</label>
        </div>
        <div class="form-group col-md-2">
          <input type="time" name="times" #time="ngModel" [(ngModel)]="course.times" class="form-control">
          <label for="default-picker">Time Start</label>
        </div>
        -
        <div class="form-group col-md-2">
          <input type="time" name="timee" #time="ngModel" [(ngModel)]="course.timee" class="form-control">
          <label for="default-picker">Time End</label>
        </div>
      </div>
      <div class="form-group">
        <input name="dayt" #dayt="ngModel" [(ngModel)]="course.dayt" class="form-control">
        <label>日期</label>
      </div>
      <div class="form-group">
        <input name="timet" #timet="ngModel" [(ngModel)]="course.timet" class="form-control">
        <label>時間</label>
      </div>
      <div class="form-group">
        <textarea name="description" #description="ngModel" [(ngModel)]="course.description" class="form-control">
        </textarea>
        <label>內容</label>
      </div>
      <div class="form-group">
        <textarea name="teacher" #teacher="ngModel" [(ngModel)]="course.teacher" class="form-control">
        </textarea>
        <label>導師</label>
      </div>
      <div class="form-group">
        <input name="tuition" #tuition="ngModel" [(ngModel)]="course.tuition" class="form-control">
        <label>學費</label>
      </div>

      <input class="form-group" type="file" accept="image/*" (change)="showPreview($event)" /> {{ upload.uploadPercent | async }}
        <div>
        <!-- <a [href]="upload.downloadURL | async">{{ upload.downloadURL | async }}</a> -->
        <img
            [src]="course.imageUrl"
            class="courseImage rounded"
          />
        </div>



      <div class="form-group">
        <button type="submit" [disabled]="form.invalid" class="btn btn-lg btn-block btn-info">SUBMIT</button>
      </div>

    </form>
  </div>
